import ContainerLandpage from 'containers/Landpage';
import { Animation } from 'ui/styled';
import { ContentAnimation, ContentBody } from './styled';

export default function NotFound() {
  return (
    <ContainerLandpage>
      <ContentBody>
        <ContentAnimation>
          <Animation animationData={require('assets/lotties/404.json')} />
        </ContentAnimation>
      </ContentBody>
    </ContainerLandpage>
  );
}
